/**
 * Список видов, разделённый по кадру карты.
 *
 * Склейка трёх вещей и ничего своего: ответ сервера (виды + регионы), кадр из
 * внешнего хранилища и чистая функция `splitSpecies`. Вся проверяемая логика
 * лежит в ней, здесь только подписка.
 *
 * Ключ запроса тот же, что у остальных четырёх мест витрины, — второго похода
 * на сервер не возникает.
 */

import { useMemo, useSyncExternalStore } from 'react'
import { useQuery } from '@tanstack/react-query'
import { cabinetApi } from '../api'
import { splitSpecies, type SplitSpecies } from './regionFilter'
import { getViewBBox, subscribeViewBBox } from './viewportStore'

export function useSpeciesInView(selected: number | null): SplitSpecies {
  const { data } = useQuery({
    queryKey: ['cabinet', 'species'],
    queryFn: () => cabinetApi.species(),
  })
  const bbox = useSyncExternalStore(subscribeViewBBox, getViewBBox, () => null)
  return useMemo(
    () => splitSpecies(data?.species ?? [], data?.regions ?? [], bbox, selected),
    [data, bbox, selected],
  )
}
